import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ShippingProviders, MAX_MARKUP_PERCENT, MAX_MARKUP_DOLLAR, MIN_MARKUP_VALUE } from '@app/shared/constants';

export enum FuelSurchargeRule {
  PERCENT = 'PERCENT',
  PER_KILO = 'PER_KILO',
  PER_POUND = 'PER_POUND',
}

@Component({
  standalone: false,
  selector: 'app-courier-settings',
  templateUrl: './courier-settings.component.html',
})
export class CourierSettingsComponent implements OnInit {
  @Input() public providerSettingsForm: FormGroup;
  @Input() public provider: ShippingProviders;
  @Input() public canEditStatus: boolean = false;
  @Input() public showAccountTypeSwitches: boolean = false;
  public showFuelPercent = false;
  public showFuelWeight = false;
  public isMetric = false;

  readonly MAX_MARKUP_PERCENT = MAX_MARKUP_PERCENT;
  readonly MAX_MARKUP_DOLLAR = MAX_MARKUP_DOLLAR;
  readonly MIN_MARKUP_VALUE = MIN_MARKUP_VALUE;

  public loading = false;
  public providerHasFuelSurcharges: boolean;

  constructor() {}

  ngOnInit() {
    this.providerSettingsForm.updateValueAndValidity();
    this.providerHasFuelSurcharges =
      this.providerSettingsForm.value.fuelSurchargeMarkupMargin != null;

    if (!!this.providerSettingsForm.get('fuelSurchargeRule').value) {
      this.showFuelPercent = this.providerSettingsForm.get('fuelSurchargeRule').value === FuelSurchargeRule.PERCENT;
      this.showFuelWeight = [FuelSurchargeRule.PER_KILO, FuelSurchargeRule.PER_POUND].includes(this.providerSettingsForm.get('fuelSurchargeRule').value);
      this.isMetric = this.providerSettingsForm.get('fuelSurchargeRule').value === FuelSurchargeRule.PER_KILO;
    }

    this.providerSettingsForm.valueChanges.subscribe((formValue) => {
      this.syncAccountTypeSwitches(formValue.enabled);
      if (formValue.fuelSurchargeRule === FuelSurchargeRule.PERCENT) {
        this.showFuelPercent = true;
        this.showFuelWeight = false;
      } else if ([FuelSurchargeRule.PER_KILO, FuelSurchargeRule.PER_POUND].includes(formValue.fuelSurchargeRule)) {
        this.showFuelWeight = true;
        this.showFuelPercent = false;
        this.isMetric = formValue.fuelSurchargeRule === FuelSurchargeRule.PER_KILO;
      }
    });

    this.disableMarkupField();
    this.syncAccountTypeSwitches(this.providerSettingsForm.get('enabled')?.value);
  }

  private syncAccountTypeSwitches(statusEnabled: boolean | null): void {
    ['maEnabled', 'byoaEnabled'].forEach((controlName) => {
      const control = this.providerSettingsForm.get(controlName);
      if (!control) return;
      if (statusEnabled === false) control.disable({ emitEvent: false });
      else control.enable({ emitEvent: false });
    });
  }

  public disableMarkupField(): void {
    const markupDollarValue =
      this.providerSettingsForm.controls['markupDollarValue'].value;
    const markupPercentageValue =
      this.providerSettingsForm.controls['markupPercentageValue'].value;
    if (markupDollarValue) {
      this.providerSettingsForm.get('markupDollarValue').enable();
      this.providerSettingsForm.get('markupPercentageValue').disable();
    }
    if (markupPercentageValue) {
      this.providerSettingsForm.get('markupPercentageValue').enable();
      this.providerSettingsForm.get('markupDollarValue').disable();
    }
  }

  public keyPressed($event) {
    if ($event.target.value.length === 0) {
      this.providerSettingsForm.controls['markupDollarValue'].enable();
      this.providerSettingsForm.controls['markupPercentageValue'].enable();
    }
    if (
      $event.target &&
      $event.target.id === 'markupPercentageValue' &&
      $event.target.value.length > 0
    ) {
      this.providerSettingsForm.controls['markupDollarValue'].disable();
    }
    if (
      $event.target &&
      $event.target.id === 'markupDollarValue' &&
      $event.target.value.length > 0
    ) {
      this.providerSettingsForm.controls['markupPercentageValue'].disable();
    }
    this.providerSettingsForm.updateValueAndValidity();
  }
}
